module.exports = __webpack_public_path__ + "static/item--chloe--f6@3x.38c90bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f6@3x.png
// module id = 640
// module chunks = 126511778744290